// extracted by mini-css-extract-plugin
export default {"footerTable":"FooterTable_footerTable__PHu6K","footerTotalPrice":"FooterTable_footerTotalPrice__d+7WI"};